import { render, staticRenderFns } from "./FormFields.vue?vue&type=template&id=6881b48e&scoped=true&"
import script from "./FormFields.vue?vue&type=script&lang=js&"
export * from "./FormFields.vue?vue&type=script&lang=js&"
import style0 from "./FormFields.vue?vue&type=style&index=0&id=6881b48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881b48e",
  null
  
)

export default component.exports